﻿$.fn.dxCtrlGridEmailRecu = function custom_dxCtrlGridEmailRecu(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridemailrecu dx-ctrl");
        this.createInstance(new cdxCtrlGridEmailRecu(this, option));
    }
    return this;
}

//$(document).ready(function () {
//    function mGenereTheme() {
//        if (typeof theme.color != 'undefined') {
//            var styleVirtualGridFixedEmailRecu = document.createElement("style");
//            styleVirtualGridFixedEmailRecu.type = "text/css";
//            document.getElementsByTagName("head")[0].appendChild(styleVirtualGridFixedEmailRecu);
//            //styleVirtualGridFixedEmailRecu.innerHTML = ".nouveauemail { font-weight: 600;box-shadow: " + theme.color.replace("rgb(", "rgba(").replace(")", ",0.35)") + "  0px 0px 10px 3px inset , 0px 0px 5px 2px " + theme.backgroundcolorAccent + " inset !important; }"
//            if (parametre.isMobile) {
//                styleVirtualGridFixedEmailRecu.innerHTML = ".nouveauemail { " +
//                    "opacity:1 !important;" +
//                    "background: rgba(0, 0, 0, 0);" +
//                    "background: -webkit-linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, " + theme.backgroundcolorAccent + " 100%);" +
//                    "background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, " + theme.backgroundcolorAccent + " 100%);" +
//                    "}"
//            } else {
//                styleVirtualGridFixedEmailRecu.innerHTML = ".nouveauemail { opacity:1 !important;box-shadow: inset 0 0 5px 3px " + theme.backgroundcolorAccent + ";background-color:black !important; }"
//            }

//        } else {
//            window.setTimeout(function () { mGenereTheme() }, 100)
//        }
//    }
//    mGenereTheme()
//})

window.cdxCtrlGridEmailRecu = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "gridemailrecu"

    var _disableUpdateFunction = false
    option.bddCtrl.mAddFunctionOnModifiedItemData(["com_email_recu"], container,
        function (action, itemData) {
            if (_disableUpdateFunction) {
                _disableUpdateFunction = false
                return
            }
            if (typeof itemData != 'undefined') {
                dxGrid.mUpdateData(action, option.bddCtrl.table.mGetItemFromNom("com_email_recu").id_table, itemData.id_com_email_recu)
            } else {
                dxGrid.mUpdateData()
            }
        })

    $(document).on('receptionEmailEvent', function (e, lstComEmailRecu) { //id_com_email_recu/id_compte_email
        if (option.lstIdTypeClassement.contains("1")) {
            //on est sur une grille d'email recu
            var lstDataCompteEmail = mGetLstDataCompteEmail()
            if (lstComEmailRecu.result.filter(function (itemData) {
                return lstDataCompteEmail.filter(function (dataCpteEmail) { return itemData.id_compte_email == dataCpteEmail.id_compte_email }).length > 0
            }).length > 0) {
                dxGrid.mUpdateData()
            }
        }
    });

    var dxGrid = null
    this.mGetDxGrid = function () { return dxGrid }
    function mConstruit() {
        container.empty();
        container.css("height", "100%")

        //indefini = 0
        //boite_reception = 1
        //archive = 2
        //spam = 3
        //liste_grise = 4
        //non_delivre = 5
        //reponse_auto = 6
        //envoi_brouillon = 7
        //envoi_attente = 8
        //envoi_encours = 9
        //envoi_envoye = 10
        //envoi_erreur = 11
        //envoi_tracking = 12
        //envoi_attente_immediat = 13
        //envoi_annule = 14
        var noDataText = "Aucun email reçu"
        if (typeof option.lstIdTypeClassement != 'undefined') {
            noDataText = ""
            option.lstIdTypeClassement.forEach(function (idTypeClassement) {
                if (option.lstIdTypeClassement.length < 3) {
                    switch (parseInt(idTypeClassement)) {
                        case 1:
                            noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email reçu en boite de réception";
                            break; //brouillon
                        case 2: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email reçu en archive"; break; //attente envoi
                        case 3: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email reçu en spam"; break; //en cours d'envoi
                        case 4: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email reçu en bounce"; break; //envoyé
                        case 5: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email de notification non délivré reçu"; break; //envoyé
                        case 6: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email de réponse automatique reçu"; break; //tracking
                        case 7: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email brouillon"; break; //brouillon
                        case 8: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email en attente"; break; //brouillon
                        case 9: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email en cours d'envoi"; break; //en cours d'envoi
                        case 10: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email envoyé"; break; //en cours d'envoi
                        case 11: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email en erreur"; break; //en cours d'envoi
                        case 12: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun email en tracking"; break; //tracking
                    }
                }
            })
        }

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid({
            bddCtrl: option.bddCtrl,
            noDataText: noDataText,
            typeData: "emailrecu",
            lstLstConditionBase: mGetLstLstConditionBase(),
            context_grid: option.context_grid,
            itemsToolbar: mGetLstButtonToolBar(),
            itemsToolbarSelect: mGetLstButtonToolBarSelect,
            onDisplayButtonLigne: mGetLstButtonLigne,
            lstTypeGrille: ["Détails", "Lignes"],
            fields: mGetLstField(),
            allowCarto: false,
            allowFilter: true,
            allowLucene: true,
            allowCheck: ((typeof option.allowCheck != 'undefined') ? option.allowCheck : true),
            itemTemplateGrille: function (container, dataTemplate, type, optionTemplate) {
                var objBase = null
                if (dataTemplate.id_table_key == 0) {
                    objBase = new cObjetFile(dataTemplate, option.bddCtrl)
                } else {
                    objBase = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataTemplate.id_table_key).nom) //, option.dataTemplateDisplay.id_key)
                }
                objBase.itemTemplateGrille(container, dataTemplate, type)

                var ssTypeFrom = ""
                if (option.lstIdTypeClassement.length == 1) {
                    switch (parseInt(option.lstIdTypeClassement[0])) {
                        case 1: ssTypeFrom = "reception"; break;
                        case 2: ssTypeFrom = "archivage"; break;
                        case 3: ssTypeFrom = "antispam"; break;
                    }
                }
                getClasseurDataTournee({ bddCtrl: option.bddCtrl }).mInitDragClasseur(container.closest(".divtemplate"), dxGrid, "com_email_recu", ssTypeFrom, optionTemplate.dataGrid, function (lstElementDataGrid, toSousType) {
                    switch (ssTypeFrom) {
                        case "reception":
                            if ((toSousType != "classeur" && toSousType != "dates") ||
                                (toSousType == "classeur" && option.bddCtrl.utiCourantParaJson.parametre_general.email_dans_classeur_archivage_auto) ||
                                (toSousType == "dates" && option.bddCtrl.utiCourantParaJson.parametre_general.email_dans_dates_archivage_auto)) {
                                dxGrid.mRemoveRows(lstElementDataGrid)
                            }
                            break;
                        case "archivage":
                            if (toSousType != "classeur" && toSousType != "dates") dxGrid.mRemoveRows(lstElementDataGrid)
                            break;
                        case "antispam":
                            dxGrid.mRemoveRows(lstElementDataGrid)
                            break;
                    }
                })
            },
            onEndLoadData: function () {
                option.bddCtrl.mAjaxCall({ command: "updateemailrecudateprochainereception", data: mGetLstDataCompteEmail() })
                option.bddCtrl.msgEmailSms.mUpdateLstIdComEmailRecuVisu(dxGrid.mGetLstData())
            },
            onSelectionChanged: function () {
                //if (dxBtDeplaceEllipsis) {
                //    dxBtDeplaceEllipsis.option("disabled", dxGrid.mGetLstSelectedData().length == 0)
                //    dxBtDeplaceEllipsis.mRempliCompteur(dxGrid.mGetLstSelectedData().length)
                //}
                //if (dxBtVueEllipsis) {
                //    dxBtVueEllipsis.option("disabled", dxGrid.mGetLstSelectedData().length == 0)
                //    dxBtVueEllipsis.mRempliCompteur(dxGrid.mGetLstSelectedData().length)
                //}
                if (typeof option.onSelectionChanged != 'undefined') option.onSelectionChanged()
            }
        }).dxCtrlVirtualGrid("instance")

        if (typeof option.lstIdTypeClassement != 'undefined' && option.lstIdTypeClassement.length == 1 && option.lstIdTypeClassement[0] == 3) {
            mNotify("Chaque nuit, vos spams sont vidés automatiquement et seuls les messages des <b>30 derniers jours</b> sont conservés.", "success", 8000)
        }
    }

    this.mSwitchCheck = function () { dxGrid.mSwitchCheck() }

    function mGetLstDataCompteEmail() {
        var lstDataCpteEmail = []
        if (option.adresse_email.toLowerCase() == "favori") {
            lstDataCpteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) {
                return option.bddCtrl.mGetArray("compte_email_utilisateur").filter(function (oo) {
                    return oo.id_utilisateur == option.bddCtrl.utiCourant.id_utilisateur && oo.id_compte_email == o.id_compte_email && oo.in_favori == 1
                }).length > 0
            })
        } else {
            lstDataCpteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) {
                return o.adresse_email == option.adresse_email
            })
        }
        return lstDataCpteEmail
    }

    function mGetLstField() {
        var lst = []
        lst.push({
            name: "date_reception",
            dataField: "date_reception",
            caption: "Date réception",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "date",
            filterLinkGrp: "date_reception_tri",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.date_reception.toGrpDate().id
            },
            calculateSortValue: function (rowData) {
                return rowData.date_reception
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Réception: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
        })
        if (parametre.isMobile) {
            lst[0].sortIndex = 0
            lst[0].sortOrder = "desc"
        } else {
            lst[0].groupIndex = 0
            lst[0].sortOrder = "desc"
        }
        lst.push({
            name: "date_reception_tri",
            dataField: "date_reception_tri",
            allowGrid: true,
            visible: false
        })

        lst.push({
            name: "dcr",
            dataField: "dcr",
            caption: "Date création",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "date",
            filterLinkGrp: "dcr_tri",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            calculateSortValue: function (rowData) {
                return rowData.dcr
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Création: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
        })
        lst.push({
            name: "dcr_tri",
            dataField: "dcr_tri",
            allowGrid: true,
            visible: false
        })

        var lst = lst.concat([{
            name: "email_destinataire",
            dataField: "email_destinataire",
            caption: "Email destinataire",
            icon: "fas fa-at",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-at dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + options.column.caption + ": " + options.displayValue + " (" + tot + ")")
            }
        }, {
            name: "nouveau",
            dataField: "nouveau",
            caption: "Lu",
            icon: "fas fa-eye",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "boolean",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + "Email" + ((tot > 1) ? "s" : "") + " non lu" + ((tot > 1) ? "s" : "") + " (" + tot + ")")
            },
            filterProperty: {
                filterOperations: ["lu", "nonlu"]
            }
        }, {
            name: "taille_octet",
            dataField: "taille_octet",
            caption: "taille",
            icon: "fas fa-weight-hanging",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            calculateGroupValue: function (rowData) {
                return Math.ceil(rowData.taille_octet / 1024 / 1024)
            },
            groupCellTemplate: function (columnElement, options) {
                var txt = ""
                switch (options.key[0]) {
                    case 1: txt = "< 1Mo"; break;
                    default:
                        txt = "entre " + (options.key[0] - 1) + "Mo et " + options.key[0] + "Mo";
                        break;
                }
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-weight-hanging dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + options.column.caption + ": " + txt + " (" + tot + ")")
            },
            calculateCellValue: function (rowData) {
                return rowData.taille_octet
            },
            calculateSortValue: function (rowData) {
                return rowData.taille_octet
            },
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">="],
                editorTemplate(conditionInfo, itemElement) {
                    var value = ""
                    if (conditionInfo.value == null) { value = 1024 * 1024; }
                    else { value = conditionInfo.value }
                    conditionInfo.setValue(value);

                    if (value >= 1024) {
                        if (value >= 1024 * 1024) {
                            if (value >= 1024 * 1024 * 1024) {
                                value = value / 1024 / 1024 / 1024 + "|Go"
                            } else {
                                value = value / 1024 / 1024 + "|Mo"
                            }
                        } else {
                            value = value / 1024 + "|Ko"
                        }
                    } else {
                        value = value + "|o"
                    }

                    var $Div = $("<div class='ctrlinfilterbuilder'/>").appendTo(itemElement)
                    var $Table = $("<table/>").appendTo($Div)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td/>").appendTo($Tr)
                    var dxTaille = $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlSaisieTailleFichier({
                        min: 0,
                        width: 60,
                        isFloat: false,
                        noNull: true,
                        value: value,
                        onValueChanged: function (e) {
                            if (!e.value.endsWith("|o")) {
                                if (!e.value.endsWith("|Ko")) {
                                    if (!e.value.endsWith("|Mo")) {
                                        conditionInfo.setValue(parseInt(e.value.replace("|Go", "")) * 1024 * 1024 * 1024);
                                    } else {
                                        conditionInfo.setValue(parseInt(e.value.replace("|Mo", "")) * 1024 * 1024);
                                    }
                                } else {
                                    conditionInfo.setValue(parseInt(e.value.replace("|Ko", "")) * 1024);
                                }
                            } else {
                                conditionInfo.setValue(parseInt(e.value.replace("|o", "")));
                            }

                        }
                    }).dxCtrlSaisieTailleFichier("instance")
                    var $Td = $("<td/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        icon: "fas fa-check",
                        onClick: function (e) {
                            conditionInfo.closeEditor()
                        }
                    })
                },
                customizeText: function (fieldInfo) {
                    if (fieldInfo.value >= 1024) {
                        if (fieldInfo.value >= 1024 * 1024) {
                            if (fieldInfo.value >= 1024 * 1024 * 1024) {
                                return fieldInfo.value / 1024 / 1024 / 1024 + " Go"
                            } else {
                                return fieldInfo.value / 1024 / 1024 + " Mo"
                            }
                        } else {
                            return fieldInfo.value / 1024 + " Ko"
                        }
                    } else {
                        return fieldInfo.value + " o"
                    }
                },
                //calculateFilterExpression(filterValue, field) {
                //    //["o", "Ko", "Mo", "Go"],
                //    return filterValue.split("|")[0] * ((filterValue.split("|")[1] == "o") ? 1 : ((filterValue.split("|")[1] == "Ko") ? 1024 : ((filterValue.split("|")[1] == "Mo") ? 1024*1024 : 1024*1024*1024)))
                //}
            }
        }, {
            name: "nb_fichier_joint",
            dataField: "nb_fichier_joint",
            caption: "Nbre fichier joint",
            icon: "fas fa-paperclip",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-paperclip dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + options.displayValue + " fichier" + ((tot > 1) ? "s" : "") + " (" + tot + ")")
            }
        }, {
            name: "id_utilisateur",
            dataField: "id_utilisateur",
            caption: "Utilisateur",
            icon: "fas fa-user",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            calculateGroupValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            groupCellTemplate: function (columnElement, options) {
                var txt = options.data.key
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-user dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + txt + " (" + tot + ")")
            },
            calculateCellValue: function (rowData) {
                return rowData.id_utilisateur
            },
            calculateSortValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            filterProperty: {
                lookup: option.bddCtrl.getObjet("utilisateur").objetMetier.mGetLookUpForFilterBuilder(),
                filterOperations: ["parmi", "notparmi"]
            }
        }, {
            name: "objet",
            dataField: "objet",
            caption: "Objet",
            allowFilter: true,
            allowGrid: false,
            dataType: "string"
        }, {
            name: "body_txt",
            dataField: "body_txt",
            caption: "Corps du mail",
            allowFilter: true,
            allowGrid: false,
            dataType: "string"
        }, {
            name: "nom_usuel_expediteur",
            dataField: "nom_usuel_expediteur",
            caption: "Nom usuel expéditeur",
            allowFilter: true,
            allowGrid: false,
            dataType: "string"
        }, {
            name: "id_compte_email",
            dataField: "id_compte_email",
            caption: "id_compte_email",
            allowFilter: false,
            allowGrid: false,
            dataType: "number"
        }])
        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []

        if (typeof option.showBtNew == 'undefined' || option.showBtNew) {
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-envelope",
            //            icon2: "fas fa-certificate",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            txtTooltip: "Nouvel email",
            //            onClick: function (e) {
            //                option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail()
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-square-envelope",
            //            icon2: "fas fa-certificate",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            txtTooltip: "Nouvel emailing",
            //            onClick: function (e) {
            //                option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail(true)
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-envelope-open-text",
            //            icon2: "fas fa-certificate",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            icon3: "fas fa-boxes",
            //            opacityIcone3: "0.7",
            //            colorIcone3: theme.color,
            //            leftIcone3: true,
            //            txtTooltip: "Nouveau document email dans la box",
            //            onClick: function (e) {
            //                (new cObjetFichierEmlzMetier(null, option.bddCtrl)).mShowNewDocumentEmail()
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
        }

        return items
    }
    //var dxBtVueEllipsis = null
    //var dxBtDeplaceEllipsis = null
    function mGetLstButtonToolBarSelect(dxVirtualGrid) {
        var items = []
        if (typeof option.showBtTraitement == 'undefined' || option.showBtTraitement) {
            var itemToolbar = {
                location: 'before',
                visible: (dxVirtualGrid && dxVirtualGrid.toolbarSelectIsVisible),
                template: function (itemData, itemIndex, itemElement) {
                    var dxBtVueEllipsis = $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-eye",
                        icon2: "fas fa-ellipsis",
                        colorIcone2: theme.colorBtIcon2,
                        hint: "Marquer les messages sélectionnés comme lu/non lu",
                        opacityIcone2: "0.9",
                        onClick: function (e) {
                            Me.mShowMenuLuNonLu(e.component.element())
                        }
                    }).dxCtrlButton("instance")
                    dxVirtualGrid.lstButtonForCheck.push(dxBtVueEllipsis)
                }
            }
            dxVirtualGrid.lstItemToolbarForCheck.push(itemToolbar)
            items.push(itemToolbar)

            var itemToolbar = {
                location: 'before',
                visible: (dxVirtualGrid && dxVirtualGrid.toolbarSelectIsVisible),
                template: function (itemData, itemIndex, itemElement) {
                    var dxBtDeplaceEllipsis = $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-square-caret-down",
                        icon2: "fas fa-ellipsis",
                        colorIcone2: theme.colorBtIcon2,
                        opacityIcone2: "0.9",
                        hint: "Déplacer les messages sélectionné dans...",
                        onClick: function (e) {
                            Me.mShowMenuDeplacer(e.component.element())
                        }
                    }).dxCtrlButton("instance")
                    dxVirtualGrid.lstButtonForCheck.push(dxBtDeplaceEllipsis)
                }
            }
            dxVirtualGrid.lstItemToolbarForCheck.push(itemToolbar)
            items.push(itemToolbar)
        }
        return items
    }

    this.mShowMenuLuNonLu = function (target) {
        var confirm = (dxGrid.mGetLstSelectedData().length == 0)
        var lstDataTraitement = Me.mGetLstTraitementData()

        if (lstDataTraitement.length > 0) {
            var actionSheet = $("<div style='z-index:" + (mGetMaxZindexElement($("body")) + 1) + ";'/>").appendTo("body").dxActionSheet({
                dataSource: [{ text: "Lu", icon: "fas fa-eye-slash" }, { text: "Non lu", icon: "fas fa-eye" }],
                title: 'Marquer ' + lstDataTraitement.length + ' email' + ((lstDataTraitement.length > 1) ? "s" : "") + ' comme...',
                onCancelClick() {
                },
                onItemClick(value) {
                    switch (value.itemData.text) {
                        case "Lu":
                            if (confirm) {
                                mConfirmTooltip(target, "Mettre tous les emails en lu", function () { mActionLu() })
                            } else { mActionLu() }

                            function mActionLu() {
                                var lstId = ""
                                lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                                option.bddCtrl.mAjaxCall({
                                    command: "modifchampemaillstidcomemailrecu",
                                    nomchamp: "nouveau",
                                    lstid: lstId,
                                    value: 0
                                }, function (data) {
                                    if (lstDataTraitement.length < 200) { dxGrid.mUpdateData() } else { dxGrid.mReloadData(false) }
                                    mNotify(lstDataTraitement.length + " email" + ((lstDataTraitement.length > 1) ? "s" : "") + " marqué" + ((lstDataTraitement.length > 1) ? "s" : "") + " comme <b>lu</b>", "success", 6000)
                                })
                            }
                            break;
                        case "Non lu":
                            if (confirm) {
                                mConfirmTooltip(target, "Mettre tous les emails en non lu", function () { mActionNonLu() })
                            } else { mActionNonLu() }

                            function mActionNonLu() {
                                var lstId = ""
                                lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                                option.bddCtrl.mAjaxCall({
                                    command: "modifchampemaillstidcomemailrecu",
                                    nomchamp: "nouveau",
                                    lstid: lstId,
                                    value: 1
                                }, function (data) {
                                    if (lstDataTraitement.length < 200) { dxGrid.mUpdateData() } else { dxGrid.mReloadData(false) }
                                    mNotify(lstDataTraitement.length + " email" + ((lstDataTraitement.length > 1) ? "s" : "") + " marqué" + ((lstDataTraitement.length > 1) ? "s" : "") + " comme <b>non lu</b>", "success", 6000)
                                })
                            }
                            break;
                    }
                },
                onItemRendered: function (e) {
                    e.itemElement.find(".dx-icon").addClass("dx-theme-accent-as-text-color")
                },
                onContentReady: function (e) {
                    $("body").find(".dx-actionsheet-popup-wrapper").on("click", function () {
                        e.component.hide()
                    })
                }
            }).dxActionSheet('instance');
            if (!parametre.isMobile) {
                actionSheet.option({
                    usePopover: true,
                    target: target
                })
            }
            actionSheet.option('visible', true);
        }
    }
    this.mShowMenuDeplacer = function (target) {
        var confirm = (dxGrid.mGetLstSelectedData().length == 0)
        var lstDataTraitement = Me.mGetLstTraitementData()

        if (lstDataTraitement.length > 0) {
            var ds = []
            if (!option.lstIdTypeClassement.contains(1)) ds.push({ text: "En boite de réception", icon: "fas fa-inbox", hint: "Mettre tous les emails sélectionnés en boite de réception" })
            if (!option.lstIdTypeClassement.contains(2)) ds.push({ text: "Archiver", icon: "fas fa-box-archive", hint: "Archiver tous les emails sélectionnés" })
            if (!option.lstIdTypeClassement.contains(3)) ds.push({ text: "SPAM", icon: "fas fa-shield", hint: "Mettre tous les emails sélectionnés en SPAM" })
            if (option.bddCtrl.objCptCli.objetMetier.hasDates()) ds.push({ text: "Classeurs/Dates...", icon: "fas fa-book", hint: "Mettre tous les emails sélectionnés dans un classeur ou une date" })
            var fromType = ""
            if (option.lstIdTypeClassement[0] == "1") { fromType = "reception" }
            else if (option.lstIdTypeClassement[0] == "2") { fromType = "archivage" }
            else if (option.lstIdTypeClassement[0] == "3") { fromType = "antispam" }
            var actionSheet = $("<div style='z-index:" + (mGetMaxZindexElement($("body")) + 1) + ";'/>").appendTo("body").dxActionSheet({
                dataSource: ds,
                title: 'Déplacer ' + lstDataTraitement.length + ' email' + ((lstDataTraitement.length > 1) ? "s" : "") + '...',
                hint: 'Déplacer ' + lstDataTraitement.length + ' email' + ((lstDataTraitement.length > 1) ? "s" : "") + '...',
                width: 300,
                onCancelClick() {
                },
                itemTemplate: function (itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxButton({
                        text: itemData.text,
                        icon: itemData.icon,
                        hint: itemData.hint
                    })
                },
                onItemClick(value) {
                    switch (value.itemData.text) {
                        case "En boite de réception":
                            if (confirm) {
                                mConfirmTooltip(target, "Mettre tous les emails en boite de réception", function () { mActionReception() })
                            } else { mActionReception() }

                            function mActionReception() {
                                option.bddCtrl.mAjaxCall({
                                    command: "deplacecommunication",
                                    table_source: "com_email_recu",
                                    lst_element: lstDataTraitement,
                                    id_classeur: null,
                                    from_sous_type: fromType,
                                    to_sous_type: "reception"
                                }, function (data) {
                                    dxGrid.mReloadData(false)
                                    mNotify(lstDataTraitement.length + " email" + ((lstDataTraitement.length > 1) ? "s" : "") + " mise en <b>boite de reception</b>", "success", 6000)
                                })
                                //var lstId = ""
                                //lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                                //option.bddCtrl.mAjaxCall({
                                //    command: "modifchampemaillstidcomemailrecu",
                                //    nomchamp: "id_type_classement",
                                //    lstid: lstId,
                                //    value: 1
                                //}, function (data) {
                                //    dxGrid.mReloadData(false)
                                //    mNotify(lstDataTraitement.length + " email" + ((lstDataTraitement.length > 1) ? "s" : "") + " mise en <b>boite de reception</b>", "success", 6000)
                                //})
                            }
                            break;
                        case "Archiver":
                            if (confirm) {
                                mConfirmTooltip(target, "Mettre tous les emails en archive", function () { mActionArchiver() })
                            } else { mActionArchiver() }

                            function mActionArchiver() {
                                option.bddCtrl.mAjaxCall({
                                    command: "deplacecommunication",
                                    table_source: "com_email_recu",
                                    lst_element: lstDataTraitement,
                                    id_classeur: null,
                                    from_sous_type: fromType,
                                    to_sous_type: "archivage"
                                }, function (data) {
                                    option.bddCtrl.msgEmailSms.mGetData(true)
                                    dxGrid.mReloadData(false)
                                    mNotify(lstDataTraitement.length + " email" + ((lstDataTraitement.length > 1) ? "s" : "") + " <b>archivé" + ((lstDataTraitement.length > 1) ? "s" : "") + "</b>", "success", 6000)
                                })
                                //var lstId = ""
                                //lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                                //option.bddCtrl.mAjaxCall({
                                //    command: "modifchampemaillstidcomemailrecu",
                                //    nomchamp: "id_type_classement",
                                //    lstid: lstId,
                                //    value: 2
                                //}, function (data) {
                                //    dxGrid.mReloadData(false)
                                //    mNotify(lstDataTraitement.length + " email" + ((lstDataTraitement.length > 1) ? "s" : "") + " <b>archivé" + ((lstDataTraitement.length > 1) ? "s" : "") + "</b>", "success", 6000)
                                //})
                            }
                            break;
                        case "SPAM":
                            if (confirm) {
                                mConfirmTooltip(target, "Mettre tous les emails en SPAM", function () { mActionSpam() })
                            } else { mActionSpam() }

                            function mActionSpam() {
                                option.bddCtrl.mAjaxCall({
                                    command: "deplacecommunication",
                                    table_source: "com_email_recu",
                                    lst_element: lstDataTraitement,
                                    id_classeur: null,
                                    from_sous_type: fromType,
                                    to_sous_type: "antispam"
                                }, function (data) {
                                    option.bddCtrl.msgEmailSms.mGetData(true)
                                    dxGrid.mReloadData(false)
                                    mNotify(lstDataTraitement.length + " email" + ((lstDataTraitement.length > 1) ? "s" : "") + " mise" + ((lstDataTraitement.length > 1) ? "s" : "") + " <b>en spam</b>", "success", 6000)
                                })
                                //var lstId = ""
                                //lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                                //option.bddCtrl.mAjaxCall({
                                //    command: "modifchampemaillstidcomemailrecu",
                                //    nomchamp: "id_type_classement",
                                //    lstid: lstId,
                                //    value: 3
                                //}, function (data) {
                                //    dxGrid.mReloadData(false)
                                //    mNotify(lstDataTraitement.length + " email" + ((lstDataTraitement.length > 1) ? "s" : "") + " mise" + ((lstDataTraitement.length > 1) ? "s" : "") + " <b>en spam</b>", "success", 6000)
                                //})
                            }
                            break;
                        case "Classeurs/Dates...":
                            $("<div/>").appendTo("body").dxCtrtlPopupSelectClasseurDates({
                                bddCtrl: option.bddCtrl,
                                onItemClick: function (itemData) {
                                    if (typeof itemData.id_classeur != 'undefined') {
                                        //on a sélectionné un classeur
                                        option.bddCtrl.mAjaxCall({
                                            command: "deplacecommunication",
                                            table_source: "com_email_recu",
                                            lst_element: lstDataTraitement,
                                            id_classeur: itemData.id_classeur,
                                            from_sous_type: fromType,
                                            to_sous_type: "classeur"
                                        }, function (data) {
                                            option.bddCtrl.msgEmailSms.mGetData(true)
                                            dxGrid.mReloadData(false)
                                            mNotify(lstDataTraitement.length + " email" + ((lstDataTraitement.length > 1) ? "s" : "") + " glissé" + ((lstDataTraitement.length > 1) ? "s" : "") + " dans le classeur", "success", 6000)
                                        })
                                    } else if (typeof itemData.id_dates != 'undefined') {
                                        //on a sélectionné une date
                                        option.bddCtrl.mAjaxCall({
                                            command: "deplacecommunication",
                                            table_source: "com_email_recu",
                                            lst_element: lstDataTraitement,
                                            id_dates: itemData.id_dates,
                                            from_sous_type: fromType,
                                            to_sous_type: "dates"
                                        }, function (data) {
                                            option.bddCtrl.msgEmailSms.mGetData(true)
                                            dxGrid.mReloadData(false)
                                            mNotify(lstDataTraitement.length + " email" + ((lstDataTraitement.length > 1) ? "s" : "") + " glissé" + ((lstDataTraitement.length > 1) ? "s" : "") + " dans la date", "success", 6000)
                                        })
                                    }
                                }
                            })

                            break;
                    }
                },
                onItemRendered: function (e) {
                    e.itemElement.find(".dx-icon").addClass("dx-theme-accent-as-text-color")
                },
                onContentReady: function (e) {
                    $("body").find(".dx-actionsheet-popup-wrapper").on("click", function () {
                        e.component.hide()
                    })
                }
            }).dxActionSheet('instance');
            if (!parametre.isMobile) {
                actionSheet.option({
                    usePopover: true,
                    target: target
                })
            }
            actionSheet.option('visible', true);
        }
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {

        toolbar.element().css("opacity", "1")
        if (typeof dataTemplate == 'undefined') debugger;
        var confidentiel = dataTemplate.confidentiel
        if (confidentiel == null) {
            var dataCompteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) { return o.id_compte_email == dataTemplate.id_compte_email })[0]
            confidentiel = ((typeof dataCompteEmail == 'undefined') ? "0" : dataCompteEmail.confidentiel)
        }

        var lstItems = []
        lstItems.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            options: {
                elementAttr: { class: "dx-button-grille-ligne" },
                icon: ((confidentiel == "0") ? 'fas fa-lock-open' : 'fas fa-lock'),
                hint: ((confidentiel == "0") ? 'Cet email est publique.<br/>Cliquer pour le rendre confidentiel' : 'Cet email est confidentiel.<br/>Cliquer pour le rendre publique'),
                focusStateEnabled: false,
                text: ((confidentiel == "0") ? 'Email publique' : 'Email confidentiel'),
                //hint: ((confidentiel == "0") ? 'Email publique' : 'Email confidentiel'),
                onClick(e) {
                    if (typeof e != "undefined") e.event.stopPropagation();
                    var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                    obj.data.confidentiel = ((confidentiel == "0") ? "1" : "0")
                    dataTemplate.confidentiel = obj.data.confidentiel
                    e.component.option("icon", ((dataTemplate.confidentiel == "0") ? 'fas fa-lock-open' : 'fas fa-lock'))
                    if (typeof e.element[0].tt != 'undefined') e.element[0].tt.remove()
                    e.component.option("hint", ((dataTemplate.confidentiel == "0") ? 'Cet email est publique.<br/>Cliquer pour le rendre confidentiel' : 'Cet email est confidentiel.<br/>Cliquer pour le rendre publique'))
                    if (typeof e.element[0].t != 'undefined') e.element[0].t = e.component.option("hint")
                    e.element.find(".fas").css("color", ((dataTemplate.confidentiel == "0") ? 'green' : 'red'))
                    _disableUpdateFunction = true
                    obj.mSaveChamp("confidentiel")
                    mNotify("Votre message est mainteannt " + (dataTemplate.confidentiel == "0" ? 'publique' : 'confidentiel') + " dans " + parametre.nom, "success", 3000)
                },
                onContentReady: function (e) {
                    e.element.find(".fas").css("color", ((dataTemplate.confidentiel == "0") ? 'green' : 'red'))
                }
            },
        })
        lstItems.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            mobile: {
                index: 1,
                color: "orange",
                position: "right"
            },
            options: {
                elementAttr: { class: "dx-button-grille-ligne" },
                icon: 'fas fa-reply',
                focusStateEnabled: false,
                text: "Répondre",
                hint: "Répondre",
                onClick(e) {
                    if (typeof e != "undefined") e.event.stopPropagation();
                    page.mAddPopup(option.bddCtrl.getObjet("com_email_envoi").mGetNewData(), {
                        nomTable: "com_email_envoi",
                        funcCreate: function (funcOk) {
                            option.bddCtrl.mAjaxCall({ command: "repondrerecu", id_com_email_recu: dataGrid.id }, function (data) {
                                funcOk(option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).data)
                            })
                        }
                    })
                    //option.bddCtrl.mAjaxCall({ command: "repondrerecu", id_com_email_recu: dataGrid.id }, function (data) {
                    //    option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).mShowPopup()
                    //})
                }
            },
        })
        lstItems.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            mobile: {
                index: 0,
                color: "gray",
                position: "right"
            },
            options: {
                elementAttr: { class: "dx-button-grille-ligne" },
                icon: 'fas fa-ellipsis',
                focusStateEnabled: false,
                text: "Option",
                hint: "Option",
                onClick(e) {
                    if (typeof e != "undefined") e.event.stopPropagation();
                    var actionSheet = $("<div style='z-index:" + (mGetMaxZindexElement($("body")) + 1) + ";'/>").appendTo("body").dxActionSheet({
                        dataSource: [{ text: "Répondre", icon: "fas fa-reply" }, { text: "Répondre à tous", icon: "fas fa-reply-all" }, { text: "Transférer", icon: "fas fa-share" }],
                        title: 'Action...',
                        showTitle: parametre.isMobile,
                        usePopover: !parametre.isMobile,
                        onCancelClick() {
                        },
                        onItemClick(value) {
                            switch (value.itemData.text) {
                                case "Répondre":
                                    page.mAddPopup(option.bddCtrl.getObjet("com_email_envoi").mGetNewData(), {
                                        nomTable: "com_email_envoi",
                                        funcCreate: function (funcOk) {
                                            option.bddCtrl.mAjaxCall({ command: "repondrerecu", id_com_email_recu: dataGrid.id }, function (data) {
                                                funcOk(option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).data)
                                            })
                                        }
                                    })
                                    //option.bddCtrl.mAjaxCall({ command: "repondrerecu", id_com_email_recu: dataGrid.id }, function (data) {
                                    //    option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).mShowPopup()
                                    //})
                                    break;
                                case "Répondre à tous":
                                    page.mAddPopup(option.bddCtrl.getObjet("com_email_envoi").mGetNewData(), {
                                        nomTable: "com_email_envoi",
                                        funcCreate: function (funcOk) {
                                            option.bddCtrl.mAjaxCall({ command: "repondreatousrecu", id_com_email_recu: dataGrid.id }, function (data) {
                                                funcOk(option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).data)
                                            })
                                        }
                                    })
                                    //option.bddCtrl.mAjaxCall({ command: "repondreatousrecu", id_com_email_recu: dataGrid.id }, function (data) {
                                    //    option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).mShowPopup()
                                    //})
                                    break;
                                case "Transférer":
                                    page.mAddPopup(option.bddCtrl.getObjet("com_email_envoi").mGetNewData(), {
                                        nomTable: "com_email_envoi",
                                        funcCreate: function (funcOk) {
                                            option.bddCtrl.mAjaxCall({ command: "transfererecu", id_com_email_recu: dataGrid.id }, function (data) {
                                                funcOk(option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).data)
                                            })
                                        }
                                    })
                                    //option.bddCtrl.mAjaxCall({ command: "transfererecu", id_com_email_recu: dataGrid.id }, function (data) {
                                    //    option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).mShowPopup()
                                    //})
                                    break;
                            }
                        },
                        onItemRendered: function (e) {
                            e.itemElement.find(".dx-icon").addClass("dx-theme-accent-as-text-color")
                        },
                        onContentReady: function (e) {
                            $("body").find(".dx-actionsheet-popup-wrapper").on("click", function () {
                                e.component.hide()
                            })
                        }
                    }).dxActionSheet('instance');
                    if (!parametre.isMobile) {
                        actionSheet.option('target', e.component.element());
                    }
                    actionSheet.option('visible', true);
                }
            },
        })
        if (dataTemplate.id_type_classement != "1") {
            lstItems.push({
                location: 'before',
                widget: 'dxButton',
                showText: "inMenu",
                visible: !option.lstIdTypeClassement.contains(1),
                mobile: {
                    index: 1,
                    color: "GoldenRod",
                    position: "left"
                },
                options: {
                    elementAttr: { class: "dx-button-grille-ligne" },
                    icon: 'fas fa-inbox',
                    focusStateEnabled: false,
                    text: ((parametre.isMobile) ? "Réception" : "Boite réception"),
                    hint: "Mettre en boite de réception",
                    onClick(e) {
                        if (typeof e != "undefined") e.event.stopPropagation();
                        var fromType = ""
                        if (option.lstIdTypeClassement[0] == "1") { fromType = "reception" }
                        else if (option.lstIdTypeClassement[0] == "2") { fromType = "archivage" }
                        else if (option.lstIdTypeClassement[0] == "3") { fromType = "antispam" }
                        option.bddCtrl.mAjaxCall({
                            command: "deplacecommunication",
                            table_source: "com_email_recu",
                            lst_element: [{ id_table: dataGrid.id_table, id: dataGrid.id }],
                            id_classeur: null,
                            from_sous_type: fromType,
                            to_sous_type: "reception"
                        }, function (data) {
                            //mNotify("1 email mise en <b>boite de reception</b>", "success", 6000)
                        })
                        dxGrid.mRemoveRow(dataGrid)
                        //if (typeof e != "undefined") e.event.stopPropagation();
                        //var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                        //obj.data.id_type_classement = "1"
                        //obj.data.nouveau = "0"
                        //_disableUpdateFunction = true
                        //obj.mSave()
                        //dxGrid.mRemoveRow(dataGrid)
                        //option.bddCtrl.mAjaxCall({ command: "setemailvalide", adresse_email: dataTemplate.email_expediteur })
                    }
                },
            })
        }
        if (dataTemplate.id_type_classement != "2") {
            lstItems.push({
                location: 'before',
                widget: 'dxButton',
                showText: "inMenu",
                visible: !option.lstIdTypeClassement.contains(2),
                mobile: {
                    index: 2,
                    color: "DarkGrey",
                    position: "left"
                },
                options: {
                    elementAttr: { class: "dx-button-grille-ligne" },
                    icon: 'fas fa-box-archive',
                    focusStateEnabled: false,
                    text: "Archiver",
                    hint: "Archiver",
                    onClick(e) {
                        if (typeof e != "undefined") e.event.stopPropagation();
                        var fromType = ""
                        if (option.lstIdTypeClassement[0] == "1") { fromType = "reception" }
                        else if (option.lstIdTypeClassement[0] == "2") { fromType = "archivage" }
                        else if (option.lstIdTypeClassement[0] == "3") { fromType = "antispam" }
                        option.bddCtrl.mAjaxCall({
                            command: "deplacecommunication",
                            table_source: "com_email_recu",
                            lst_element: [{ id_table: dataGrid.id_table, id: dataGrid.id }],
                            id_classeur: null,
                            from_sous_type: fromType,
                            to_sous_type: "archivage"
                        }, function (data) {
                            option.bddCtrl.msgEmailSms.mGetData(true)
                            //mNotify("1 email <b>archivé</b>", "success", 6000)
                        })
                        dxGrid.mRemoveRow(dataGrid)

                        //var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                        //obj.data.id_type_classement = "2"
                        //obj.data.nouveau = "0"
                        //_disableUpdateFunction = true
                        //obj.mSave()
                        //dxGrid.mRemoveRow(dataGrid)
                    }
                },
            })
        }
        if (dataTemplate.id_type_classement != "3") {
            lstItems.push({
                location: 'before',
                widget: 'dxButton',
                showText: "inMenu",
                visible: !option.lstIdTypeClassement.contains(3),
                mobile: {
                    index: 3,
                    color: "LightCoral",
                    position: "left"
                },
                options: {
                    elementAttr: { class: "dx-button-grille-ligne" },
                    icon: 'fas fa-shield',
                    focusStateEnabled: false,
                    text: "En SPAM",
                    hint: "Mettre en SPAM",
                    onClick(e) {
                        if (typeof e != "undefined") e.event.stopPropagation();
                        var fromType = ""
                        if (option.lstIdTypeClassement[0] == "1") { fromType = "reception" }
                        else if (option.lstIdTypeClassement[0] == "2") { fromType = "archivage" }
                        else if (option.lstIdTypeClassement[0] == "3") { fromType = "antispam" }
                        option.bddCtrl.mAjaxCall({
                            command: "deplacecommunication",
                            table_source: "com_email_recu",
                            lst_element: [{ id_table: dataGrid.id_table, id: dataGrid.id }],
                            id_classeur: null,
                            from_sous_type: fromType,
                            to_sous_type: "antispam"
                        }, function (data) {
                            option.bddCtrl.msgEmailSms.mGetData(true)
                            //mNotify("1 email <b>archivé</b>", "success", 6000)
                        })
                        dxGrid.mRemoveRow(dataGrid)
                        //var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                        //obj.data.id_type_classement = "3"
                        //obj.data.is_in_spam = "1"
                        //obj.data.nouveau = "0"
                        //_disableUpdateFunction = true
                        //obj.mSave()
                        //dxGrid.mRemoveRow(dataGrid)
                        //option.bddCtrl.mAjaxCall({ command: "setemailnovalide", adresse_email: dataTemplate.email_expediteur })
                    }
                },
            })
        }
        lstItems.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            visible: !(option.lstIdTypeClassement.contains(3) || option.lstIdTypeClassement.contains(4) ||
                option.lstIdTypeClassement.contains(5) || option.lstIdTypeClassement.contains(6)),
            options: {
                elementAttr: { class: "dx-button-grille-ligne" },
                icon: ((dataTemplate.nouveau == "0") ? "fas fa-eye" : "fas fa-eye-slash"),
                focusStateEnabled: false,
                text: ((dataTemplate.nouveau == "1") ? "Marquer comme 'lu'" : "Marquer comme 'non lu'"),
                hint: ((dataTemplate.nouveau == "1") ? "Marquer comme 'lu'" : "Marquer comme 'non lu'"),
                onClick(e) {
                    if (typeof e != "undefined") e.event.stopPropagation();
                    var newNouveau = ((dataTemplate.nouveau == 0) ? 1 : 0)
                    dataTemplate.nouveau = newNouveau
                    dxGrid.mRepaintRow(dataGrid, false)
                    var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                    obj.data.nouveau = newNouveau
                    _disableUpdateFunction = true
                    obj.mSaveChamp("nouveau", function () { })
                }
            },
        })
        lstItems.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            mobile: {
                index: 0,
                color: "red",
                position: "left"
            },
            options: {
                elementAttr: { class: "dx-button-grille-ligne" },
                icon: "fas fa-trash-alt",
                focusStateEnabled: false,
                text: "Corbeille",
                hint: "Corbeille",
                onClick(e) {
                    if (typeof e != "undefined") e.event.stopPropagation();
                    dxGrid.mRemoveRow(dataGrid)
                    var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                    _disableUpdateFunction = true
                    obj.mDelData(function () { })
                }
            },
        })

        toolbar.option("items", lstItems)
    }

    this.mGetLstTraitementData = function () {
        var lstDataTraitement = dxGrid.mGetLstSelectedData()
        if (lstDataTraitement.length == 0) {
            lstDataTraitement = dxGrid.mGetLstData()
        }
        return lstDataTraitement
    }

    function mShowBtPlus(target) {
        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
            target: target,
            contentTemplate: function (contentElement) {
                contentElement.css("padding", "24px");
                //var nb = dxGrid.mGetLstData().length
                //var nbSelect = dxGrid.mGetLstSelectedData().length

                var confirm = (dxGrid.mGetLstSelectedData().length == 0)
                var lstDataTraitement = Me.mGetLstTraitementData()
                var totalNb = lstDataTraitement.length

                if (totalNb > 0) {
                    $("<div style='padding:10px;font-size:120%;'>" + totalNb + " email" + ((totalNb > 1) ? "s" : "") + ((nbSelect > 0) ? " sélectionné" + ((totalNb > 1) ? "s" : "") : "") + "</div>").appendTo(contentElement)
                    $("<div style='padding-top:5px'/>")
                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                        icon: "fas fa-eye",
                        width: "100%",
                        textAlign: "left",
                        text: "Marquer comme non lu",
                        onClick: function (e) {
                            tt.hide();
                            if (confirm) {
                                mConfirmTooltip(e.component.element(), "Mettre tous les emails en non lu", function () { mAction() })
                            } else { mAction() }

                            function mAction() {
                                var lstId = ""
                                lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                                option.bddCtrl.mAjaxCall({
                                    command: "modifchampemaillstidcomemailrecu",
                                    nomchamp: "nouveau",
                                    lstid: lstId,
                                    value: 1
                                }, function (data) {
                                    if (lstDataTraitement.length < 200) { dxGrid.mUpdateData() } else { dxGrid.mReloadData(false) }
                                    mNotify(totalNb + " email" + ((totalNb > 1) ? "s" : "") + " marqué" + ((totalNb > 1) ? "s" : "") + " comme <b>non lu</b>", "success", 6000)
                                })
                            }
                        }
                    })
                    $("<div style='padding-top:5px'/>").appendTo(contentElement)
                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                        icon: "fas fa-eye-slash",
                        width: "100%",
                        textAlign: "left",
                        text: "Marquer comme lu",
                        onClick: function (e) {
                            tt.hide();
                            if (confirm) {
                                mConfirmTooltip(e.component.element(), "Mettre tous les emails en lu", function () { mAction() })
                            } else { mAction() }

                            function mAction() {
                                var lstId = ""
                                lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                                option.bddCtrl.mAjaxCall({
                                    command: "modifchampemaillstidcomemailrecu",
                                    nomchamp: "nouveau",
                                    lstid: lstId,
                                    value: 0
                                }, function (data) {
                                    if (lstDataTraitement.length < 200) { dxGrid.mUpdateData() } else { dxGrid.mReloadData(false) }
                                    mNotify(totalNb + " email" + ((totalNb > 1) ? "s" : "") + " marqué" + ((totalNb > 1) ? "s" : "") + " comme <b>lu</b>", "success", 6000)
                                })
                            }

                        }
                    })
                    if (option.id_type_classement == null || option.id_type_classement == "2" || option.id_type_classement == "3") {
                        $("<div style='padding-top:5px'/>").appendTo(contentElement)
                        $("<div/>").appendTo(contentElement).dxCtrlButton({
                            icon: "fas fa-inbox",
                            width: "100%",
                            textAlign: "left",
                            text: "Mettre en boite de réception",
                            onClick: function (e) {
                                tt.hide();
                                if (confirm) {
                                    mConfirmTooltip(e.component.element(), "Mettre tous les emails en boite de réception", function () { mAction() })
                                } else { mAction() }

                                function mAction() {
                                    var lstId = ""
                                    lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                                    option.bddCtrl.mAjaxCall({
                                        command: "modifchampemaillstidcomemailrecu",
                                        nomchamp: "id_type_classement",
                                        lstid: lstId,
                                        value: 1
                                    }, function (data) {
                                        dxGrid.mReloadData(false)
                                        mNotify(totalNb + " email" + ((totalNb > 1) ? "s" : "") + " mise en <b>boite de reception</b>", "success", 6000)
                                    })
                                }
                            }
                        })
                    }
                    if (option.id_type_classement == null || option.id_type_classement == "1" || option.id_type_classement == "3") {
                        $("<div style='padding-top:5px'/>").appendTo(contentElement)
                        $("<div/>").appendTo(contentElement).dxCtrlButton({
                            icon: "fas fa-box-archive",
                            width: "100%",
                            textAlign: "left",
                            text: "Mettre en archive",
                            onClick: function (e) {
                                tt.hide();
                                if (confirm) {
                                    mConfirmTooltip(e.component.element(), "Mettre tous les emails en archive", function () { mAction() })
                                } else { mAction() }

                                function mAction() {
                                    var lstId = ""
                                    lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                                    option.bddCtrl.mAjaxCall({
                                        command: "modifchampemaillstidcomemailrecu",
                                        nomchamp: "id_type_classement",
                                        lstid: lstId,
                                        value: 2
                                    }, function (data) {
                                        dxGrid.mReloadData(false)
                                        mNotify(totalNb + " email" + ((totalNb > 1) ? "s" : "") + " <b>archivé" + ((totalNb > 1) ? "s" : "") + "</b>", "success", 6000)
                                    })
                                }
                            }
                        })
                    }
                    if (option.id_type_classement == null || option.id_type_classement == "1" || option.id_type_classement == "2") {
                        $("<div style='padding-top:5px'/>").appendTo(contentElement)
                        $("<div/>").appendTo(contentElement).dxCtrlButton({
                            icon: "fas fa-shield",
                            width: "100%",
                            textAlign: "left",
                            text: "Mettre en spam",
                            onClick: function (e) {
                                tt.hide();
                                if (confirm) {
                                    mConfirmTooltip(e.component.element(), "Mettre tous les emails en SPAM", function () { mAction() })
                                } else { mAction() }

                                function mAction() {
                                    var lstId = ""
                                    lstDataTraitement.forEach(function (data) { lstId += ((lstId.length > 0) ? "," : "") + data.id })
                                    option.bddCtrl.mAjaxCall({
                                        command: "modifchampemaillstidcomemailrecu",
                                        nomchamp: "id_type_classement",
                                        lstid: lstId,
                                        value: 3
                                    }, function (data) {
                                        dxGrid.mReloadData(false)
                                        mNotify(totalNb + " email" + ((totalNb > 1) ? "s" : "") + " mise" + ((totalNb > 1) ? "s" : "") + " <b>en spam</b>", "success", 6000)
                                    })
                                }

                            }
                        })
                    }
                }
            }
        }).dxCtrlTooltip("instance");
        tt.show();
    }

    function mGetLstLstConditionBase() {
        var lstConditionBase = []
        if (typeof option.lstIdTypeClassement != 'undefined' && option.lstIdTypeClassement.length > 0) {
            var lstId = []
            option.lstIdTypeClassement.forEach(function (idTypeClassement) {
                lstId.push({ value: idTypeClassement })
            })
            lstConditionBase.push({ nom_champ: "id_type_classement", ope: "parmi", valeur: lstId })
        }
        var lstCompteEmail = mGetLstDataCompteEmail()
        if (lstCompteEmail.length > 0) {
            var lstId = []
            lstCompteEmail.forEach(function (cptEmail) {
                lstId.push({ value: cptEmail.id_compte_email })
            })
            lstConditionBase.push({ nom_champ: "id_compte_email", ope: "parmi", valeur: lstId })
        }

        //if (option.bddCtrl.utiCourantParaJson.parametre_general.email_dans_classeur_pas_visible_en_boite) {
        //    if (option.lstIdTypeClassement.length == 1 &&
        //        option.lstIdTypeClassement.contains(1)) {
        //        //on est en boite de réception
        //        lstConditionBase.push({ nom_champ: "id_classeurs", ope: "=", valeur: { value: '' } })
        //        lstConditionBase.push({ nom_champ: "id_datess", ope: "=", valeur: { value: '' } })
        //    }
        //}

        return [lstConditionBase]
    }

    this.mUpdateSearchLucene = function (txtSearch) { dxGrid.mUpdateSearchLucene(txtSearch) }

    this.mReloadData = function () { dxGrid.mReloadData(true) }

    this.element = function () { return container }

    mConstruit();
}